import React from 'react';
import { motion } from 'framer-motion';
import { BotIcon, CalendarIcon, DatabaseIcon } from 'lucide-react';
import { Card } from './ui/Card';
export function FeaturesSection() {
  const features = [{
    icon: BotIcon,
    title: 'Instant Message Replies',
    description: 'When someone messages you on your chosen platform (Yelp, Facebook, OR Instagram), we reply in 8 seconds and guide them straight to booking an estimate on your calendar.',
    benefits: ['Responds 24/7, even at 2am', 'Directs leads to book immediately', 'Sounds professional, not robotic', 'ONE platform included ($297/mo)']
  }, {
    icon: CalendarIcon,
    title: 'Automatic Booking',
    description: 'Customers pick a time that works for them. It goes straight into your Google Calendar. You get a text and email notification.',
    benefits: ['Syncs with your Google Calendar', 'Sends you text + email alerts', 'Customers can reschedule themselves', 'No double-bookings']
  }, {
    icon: DatabaseIcon,
    title: 'Customer Tracker (CRM)',
    description: 'Every lead, message, and booked job gets saved automatically. See who needs follow-up, who booked, and who went cold.',
    benefits: ['Track every lead automatically', 'See your pipeline at a glance', 'Get reminders to follow up', 'Access from your phone']
  }];
  return <section className="py-20 px-6 bg-white" data-id="element-101">
      <div className="max-w-6xl mx-auto" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-103">
          <h2 className="text-4xl md:text-5xl font-bold text-[var(--jet-black)] mb-4" data-id="element-104">
            Here's What You Get
          </h2>
          <p className="text-xl text-[var(--graphite-gray)] max-w-2xl mx-auto" data-id="element-105">
            Three simple tools that work together to turn messages into booked
            jobs.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-106">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} data-id="element-107">
              <Card padding="lg" className="h-full flex flex-col" data-id="element-108">
                <feature.icon className="w-12 h-12 text-[var(--viridia-green)] mb-4" data-id="element-109" />
                <h3 className="text-2xl font-bold text-[var(--jet-black)] mb-3" data-id="element-110">
                  {feature.title}
                </h3>
                <p className="text-[var(--graphite-gray)] mb-6 leading-relaxed" data-id="element-111">
                  {feature.description}
                </p>
                <div className="mt-auto space-y-2" data-id="element-112">
                  {feature.benefits.map((benefit, idx) => <div key={idx} className="flex items-start gap-2 text-sm text-[var(--graphite-gray)]" data-id="element-113">
                      <span className="text-[var(--viridia-green)] mt-1" data-id="element-114">
                        ✓
                      </span>
                      <span data-id="element-115">{benefit}</span>
                    </div>)}
                </div>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}